import OtaUpgradeStatusContainer from './OtaUpgradeStatusContainer';

export default OtaUpgradeStatusContainer;
